import { ConfirmationModal } from '../../../../ui/components/pure/modal-content/confirmation-modal.component';
import { AccessControl } from '../../../../ui/components/pure/icons/AccessControl.icon';
import { useMutationDeleteAccessControl } from '../../../access-control/queries';

export interface DeleteAccessControlModalProps {
  accessControlId: string;
  label: string;
  onSuccess: () => void;
  onCancel: () => void;
}

export function DeleteAccessControlModal(props: DeleteAccessControlModalProps) {
  const deleteMutation = useMutationDeleteAccessControl();

  const onConfirm = async () => {
    await deleteMutation.mutateAsync({ accessControlID: props.accessControlId });
    props.onSuccess();
  };

  const errorMessage = deleteMutation.error ? 'Something went wrong. Please try again.' : undefined;

  return (
    <ConfirmationModal
      title="Delete Access Control?"
      onCancel={props.onCancel}
      onConfirm={onConfirm}
      content={[props.label]}
      icon={AccessControl}
      warning="Are you sure you want to delete this access control? This action cannot be undone."
      isLoading={deleteMutation.isLoading}
      errorMessage={errorMessage}
      actionButton={{
        label: 'Delete',
        color: 'danger'
      }}
      cancelButton={{
        label: 'Cancel',
        color: 'secondary'
      }}
    />
  );
}
